module.exports = __webpack_public_path__ + "img/redelia-bates.366deadd.png";